<template>
    <span class="multiple-selection" role="radiogroup" :aria-label="groupLabel">
        <span 
            v-for="(item, index) in items" 
            :key="index"
            role="radio"
            :aria-checked="item.value === selectedValue ? 'true' : 'false'"
            :aria-label="getItemAriaLabel(item)"
            :aria-disabled="item.disabled ? 'true' : 'false'"
            :tabindex="item.disabled ? -1 : (item.value === selectedValue ? 0 : -1)"
            @click="!item.disabled && selectItem(item.value)"
            @keydown.enter.prevent="!item.disabled && selectItem(item.value)"
            @keydown.space.prevent="!item.disabled && selectItem(item.value)"
            class="multiple-selection-item"
            :class="getItemClass(index, item.disabled)"
            :style="getItemStyle(index)"
        >
            {{ item.label }}
        </span>
    </span>
</template>

<script>
import definition from '../data-definition';

export default {
    name: 'MultipleSelection',
    props: {
        items: {
            type: Array,
            required: true,
            validator: (items) => {
                return items.every(item => item.value !== undefined && item.label !== undefined);
            }
        },
        selectedValue: {
            type: [String, Number, Boolean],
            default: null
        },
        itemWidth: {
            type: [String, Number],
            default: null
        },
        groupLabel: {
            type: String,
            default: ''
        },
        lang: {
            type: String,
            default: 'tr'
        }
    },
    methods: {
        getItemAriaLabel(item) {
            const labels = definition.labelDefinition;
            const state = item.value === this.selectedValue
                ? labels.a11ySelected[this.lang]
                : labels.a11yNotSelected[this.lang];
            return `${item.label}, ${state}`;
        },
        selectItem(value) {
            const item = this.items.find(item => item.value === value);
            if (!item || !item.disabled) {
                this.$emit('change', value);
            }
        },
        getItemClass(index, disabled) {
            const classes = [];
            const total = this.items.length;
            
            if (total === 1) {
                // Tek item varsa
            } else if (index === 0) {
                classes.push('left');
            } else if (index === total - 1) {
                classes.push('right');
            } else {
                classes.push('middle');
            }
            
            if (this.items[index].value === this.selectedValue) {
                classes.push('multiple-selection-selected');
            }
            
            if (disabled) {
                classes.push('multiple-selection-disabled');
            }
            
            return classes.join(' ');
        },
        getItemStyle() {
            const style = {};
            if (this.itemWidth) {
                const width = typeof this.itemWidth === 'number' ? `${this.itemWidth}px` : this.itemWidth;
                style.width = width;
                style.minWidth = width;
            }
            return style;
        }
    }
}
</script>

<style scoped>
.multiple-selection {
    display: inline-flex;
}

.multiple-selection-item {
    cursor: pointer;
    font-weight: 600;
    font-size: 15px;
    padding-left: 2px;
    padding-right: 2px;
    border-radius: 4px;
    border: solid 0.5px var(--main-color);
    padding-top: 2px;
    padding-bottom: 1px;
    color: var(--multiple-selection-item-color);
    text-align: center;
}

.multiple-selection .left {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.multiple-selection .right {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.multiple-selection .middle {
    border-radius: 0;
}

.multiple-selection-selected {
    background-color: var(--right-info-color);
    color: white !important;
}

.multiple-selection-disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
    pointer-events: none;
}
</style>
